import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '../../../shared/services/base.service';
import { AuthorityScopeResponse } from '../models/store-authority.model';

@Injectable({
  providedIn: 'root'
})
export class StoreAuthorityService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.users;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getAuthorityScopes(): Observable<AuthorityScopeResponse> {
    const url = this.getFullUrl(this.envService.authorityScopes);

    return this.http.get<AuthorityScopeResponse>(url, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  getUserAuthorityScopes(userNo: string): Observable<AuthorityScopeResponse> {
    const url = this.getFullUrl(this.envService.userAuthorityScopes, { no: userNo });

    return this.http.get<AuthorityScopeResponse>(url, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }
}
